import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d708f698"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "learn-container" }
const _hoisted_2 = {
  "data-wow-duration": "1s",
  class: "context animate__animated animate__fadeInUp wow"
}
const _hoisted_3 = {
  "data-wow-duration": "1s",
  class: "title nimate__animated animate__fadeInDown wow"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_5 = { class: "span1" }
const _hoisted_6 = { class: "right-container" }
const _hoisted_7 = {
  class: "bg animate__animated animate__fadeInLeft wow",
  alt: ""
}

import WOW from 'wowjs'
import { onMounted, ref } from "vue"

export default /*#__PURE__*/_defineComponent({
  __name: 'FourthView',
  setup(__props) {

const isHover = ref(false)
onMounted(() => {
  new WOW.WOW(
    { live: false }
  ).init()
})
const changeIndex = () => {
  sessionStorage.setItem('activeIndex', '/product')

}

return (_ctx: any,_cache: any) => {
  const _directive_lazy = _resolveDirective("lazy")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h1", null, _toDisplayString(_ctx.$t('Product Center')), 1),
        _hoisted_4
      ]),
      _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t('procontent')), 1),
      _createElementVNode("a", {
        href: "/product",
        class: _normalizeClass(["learnmore", { 'animate__animated animate__rubberBand': isHover.value }]),
        onMouseover: _cache[0] || (_cache[0] = ($event: any) => (isHover.value = true)),
        onMouseout: _cache[1] || (_cache[1] = ($event: any) => (isHover.value = false)),
        onClick: changeIndex
      }, [
        _createElementVNode("span", null, _toDisplayString(_ctx.$t('learnmore')), 1)
      ], 34)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _withDirectives(_createElementVNode("img", _hoisted_7, null, 512), [
        [_directive_lazy, require('@/assets/home-product.png')]
      ])
    ])
  ]))
}
}

})